export const requestNotificationPermission = () => {
    console.log('Requesting notification permission...');

    return Notification.permission === 'granted' ? 'already_granted' : Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            console.log('Notification permission granted.');
        } else {
            console.log('Notification permission denied.');
        }
        return permission;
    });
};
